import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id C9FEB434-571C-41C6-A0E5-1FA68368ACC3
 * name bed-single-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bed-single-outline.svg
 * tags
 * - Home Automation 
 * - Holiday 
 */
export const BedSingleOutlineIcon = createSvgIcon(<><path d="M17 10V7C17 5.9 16.11 5 15 5H9C7.9 5 7 5.9 7 7V10C5.9 10 5 10.9 5 12V17H6.33L7 19H8L8.67 17H15.33L16 19H17L17.67 17H19V12C19 10.9 18.11 10 17 10M9 7H15V10H9M17 15H7V12H17Z" /></>, 'BedSingleOutlineIcon');
export default BedSingleOutlineIcon